import React, { lazy, Suspense } from "react";
import DefaultLoader from "../utilities/loaders/DefaultLoader";

const MemberProfileContent = lazy(() => import('./MemberProfileContent'));

const MemberProfile = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <MemberProfileContent />
    </Suspense>
  );
};

export default MemberProfile;
